import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import ScrollToPlugin from "gsap/ScrollToPlugin";
import slick from "slick-carousel";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

export default {
  init() {
    if($('.block-tab-content').length){
      gsap.registerPlugin(ScrollTrigger);
      gsap.registerPlugin(ScrollToPlugin);

      var blockName = ".block-tab-content",
          anchor = ".animation-anchor",
          tabNav = ".navs-tabs",
          tabWrap = ".tab-content-wrap",
          tabNavLink = ".navs-tabs a, .mobile-nav-tabs a",
          windowW = $(window).width();

      gsap.to(tabNav, {
        scrollTrigger: {
          trigger: blockName,
          start: "top center",
        },
        autoAlpha: 1,
        y: 0,
      });

      gsap.to(tabWrap, {
        scrollTrigger: {
          trigger: blockName,
          start: "top center",
        },
        autoAlpha: 1,
        y: 0,
      });

    $(tabNavLink).on("click", function () {
      $(tabNavLink).removeClass("active");
      $(this).addClass("active");
      var link = $(this).attr("href");
      gsap.to($(window), {
        duration: 0,
        delay: -1,
        ease: "none",
        scrollTo: { y: link, offsetY: 200, scrub: 1 },
      });
    });

    
    if (windowW > 990) {
        gsap.to(tabNav, {
          scrollTrigger: {
            trigger: anchor,
            pin: tabNav,
            start: "100px center",
            end: "1000px"
          },
        });

        gsap.to(".link-1", {
          scrollTrigger: {
            trigger: ".tab-1",
            start: "top center",
            end: "bottom center",
            onEnter: () => link1(),
            onEnterBack: () => link1(),
          },
        });

        gsap.to(".link-2", {
          scrollTrigger: {
            trigger: ".tab-2",
            start: "top center",
            end: "bottom center",
            onEnter: () => link2(),
            onEnterBack: () => link2(),
          },
        });

        gsap.to(".link-3", {
          scrollTrigger: {
            trigger: ".tab-3",
            start: "top center",
            end: "bottom center",
            onEnter: () => link3(),
            onEnterBack: () => link3(),
          },
        });

        function link1() {
          $(".links").removeClass("active");
          $(".link-1").addClass("active");
        }
        function link2() {
          $(".links").removeClass("active");
          $(".link-2").addClass("active");
        }
        function link3() {
          $(".links").removeClass("active");
          $(".link-3").addClass("active");
        }
    } else if (windowW <= 990) {
      gsap.to(".mobile-nav-tabs", {
        scrollTrigger: {
          trigger: blockName,
          start: "300px center",
          end: "bottom bottom",
          toggleClass: { targets: ".mobile-nav-tabs", className: "fixed" },
        },
      });

      $(".mobile-nav-tabs").slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        adaptiveHeight: true,
        infinite: false,
        autoplay: false,
        arrows: true,
        dots: false,
        centerMode: false,
        responsive: [
          {
            breakpoint: 580,
            settings: {
              centerMode: false,
              slidesToShow: 3,
              initialSlide: 1,
            },
          },
        ],
      });
    }

    }
  },
  finalize() {},
};
